/* components/User.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { Link } from "svelte-routing";
import { fetchTodos, fetchUsers } from "../client.js";
import dataStore from "../stores/catalog.js";
import { writable, get } from "svelte/store";
import Preloader from "./Preloader.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-u395qc-style";
	style.textContent = ".header.svelte-u395qc{display:flex;flex:row}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (45:0) {:else}
function create_else_block(ctx) {
	let div1;
	let div0;
	let t0;
	let h1;
	let t1_value = /*$catalog*/ ctx[1].data.find(/*func*/ ctx[6]).name + "";
	let t1;
	let t2;
	let hr;
	let t3;
	let each_1_anchor;
	let current;

	const link = new Link({
			props: {
				to: `/zf/?page=${/*lastPage*/ ctx[3] || 1}`,
				class: "button button-small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	let each_value = /*$userInfo*/ ctx[2].data;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			create_component(link.$$.fragment);
			t0 = text("\n\t\t\t \n\t\t\t");
			h1 = element("h1");
			t1 = text(t1_value);
			t2 = space();
			hr = element("hr");
			t3 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
			attr(div0, "class", "column header svelte-u395qc");
			attr(div1, "class", "row");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(link, div0, null);
			append(div0, t0);
			append(div0, h1);
			append(h1, t1);
			insert(target, t2, anchor);
			insert(target, hr, anchor);
			insert(target, t3, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const link_changes = {};

			if (dirty & /*$$scope*/ 1024) {
				link_changes.$$scope = { dirty, ctx };
			}

			link.$set(link_changes);
			if ((!current || dirty & /*$catalog, userId*/ 3) && t1_value !== (t1_value = /*$catalog*/ ctx[1].data.find(/*func*/ ctx[6]).name + "")) set_data(t1, t1_value);

			if (dirty & /*$userInfo*/ 4) {
				each_value = /*$userInfo*/ ctx[2].data;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i(local) {
			if (current) return;
			transition_in(link.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(link.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(link);
			if (detaching) detach(t2);
			if (detaching) detach(hr);
			if (detaching) detach(t3);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (43:0) {#if $catalog.loading || $userInfo.loading}
function create_if_block(ctx) {
	let current;
	const preloader = new Preloader({});

	return {
		c() {
			create_component(preloader.$$.fragment);
		},
		m(target, anchor) {
			mount_component(preloader, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(preloader.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(preloader.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(preloader, detaching);
		}
	};
}

// (48:3) <Link to={`/zf/?page=${lastPage || 1}`} class="button button-small">
function create_default_slot(ctx) {
	let t;

	return {
		c() {
			t = text("back");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (64:1) {#each $userInfo.data as item}
function create_each_block(ctx) {
	let div1;
	let div0;
	let t0_value = (/*item*/ ctx[7].completed ? "✔" : "\t○") + "";
	let t0;
	let t1;
	let t2_value = /*item*/ ctx[7].title + "";
	let t2;
	let t3;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			t0 = text(t0_value);
			t1 = text("  ");
			t2 = text(t2_value);
			t3 = space();
			attr(div0, "class", "column");
			attr(div1, "class", "row");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, t0);
			append(div0, t1);
			append(div0, t2);
			append(div1, t3);
		},
		p(ctx, dirty) {
			if (dirty & /*$userInfo*/ 4 && t0_value !== (t0_value = (/*item*/ ctx[7].completed ? "✔" : "\t○") + "")) set_data(t0, t0_value);
			if (dirty & /*$userInfo*/ 4 && t2_value !== (t2_value = /*item*/ ctx[7].title + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$catalog*/ ctx[1].loading || /*$userInfo*/ ctx[2].loading) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $catalog;
	let $userInfo;
	const lastPage = localStorage.getItem("lp");
	const catalog = dataStore(fetchUsers);
	component_subscribe($$self, catalog, value => $$invalidate(1, $catalog = value));
	catalog.fetchQuery({ page: lastPage });
	const userInfo = dataStore(fetchTodos);
	component_subscribe($$self, userInfo, value => $$invalidate(2, $userInfo = value));
	let { userId } = $$props;
	userInfo.fetchQuery({ userId });

	const func = user => {
		console.log(user);
		return userId == user.id;
	};

	$$self.$set = $$props => {
		if ("userId" in $$props) $$invalidate(0, userId = $$props.userId);
	};

	return [userId, $catalog, $userInfo, lastPage, catalog, userInfo, func];
}

class User extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-u395qc-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { userId: 0 });
	}
}

export default User;